import React from "react";
import EmployeeInfo from "../../component/EmployeeDeatils/EmployeeDetails.tsx";

const EmployeeDetails = () => {
  return <EmployeeInfo />;
};

export default EmployeeDetails;
